import { InjectionToken } from '@angular/core';

import type { NbaParamResolver } from './nba-param-resolver.interface';

export const nbaParamResolverToken: InjectionToken<NbaParamResolver> = new InjectionToken<NbaParamResolver>(
  'NbaParamResolver'
);
